<template>
  <div class="course-item" @click="clickCourse(row.id)">
    <div class="img">
      <VanImg
        width="100%"
        height="100%"
        fit="cover"
        lazy-load
        :src="row.courseCoverUrl"
      />
      <div class="learned">{{ row.learnCount || 0 }}人已学</div>
    </div>
    <div class="item-right">
      <div class="course-tit" :class="{ vline: row.name.length < 10 }">
        {{ row.name }}
        <!-- 定个饭水电费感受到定个饭水电费感受到定个饭水电费感受到 -->
      </div>
      <div>
        <span class="course-info">
          <span v-if="row.knowledgeCount">
            知识点*{{ row.knowledgeCount || 0 }}节
          </span>
          <span v-if="row.knowledgeCount && row.testPaperCount"> | </span>
          <span v-if="row.testPaperCount">
            试卷*{{ row.testPaperCount || 0 }}
          </span>
        </span>
        <!-- row.sellType == 1
            ? "免费"
            : isConvert
            ? "¥" + (row.finalPriceCNY || 0)
            : "¥" + (row.orgCoursePriceCNY || 0) -->
        <span class="course-price">{{ row | priceFilter(isConvert) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImg, Lazyload } from "vant";
Vue.use(Lazyload);
export default {
  name: "CourseItem",
  props: {
    row: Object,
    isConvert: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    priceFilter: function(row, isConvert) {
      // sellType 1:免费 2：付费；timeLimitFreeFlag 限时免费 1是 0不是
      let msg = "";
      if (row.sellType == 1) {
        msg = "免费";
      } else if (row.sellType == 2) {
        if (row.timeLimitFreeFlag == 1) {
          msg = "免费";
        } else {
          isConvert
            ? (msg = "¥" + (row.finalPriceCNY || 0))
            : (msg = "¥" + (row.orgCoursePriceCNY || 0));
        }
      }
      return msg;
    }
  },
  methods: {
    clickCourse(id) {
      this.$emit("clickBackFn", id);
      setTimeout(() => {
        window.location.href =
          "./goodsDetails.html?id=" + id + "&isConvert=" + this.isConvert;
      }, 500);
    }
  },
  components: { VanImg }
};
</script>

<style scoped lang="scss">
.course-item {
  width: 340px;
  height: 94px;
  border-radius: 3px;
  margin: 0 auto 16px;
  display: flex;
  justify-content: space-between;
  // flex-direction: column;
  align-items: center;
  // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  .img {
    width: 165px;
    height: 94px;
    flex-shrink: 0;
    position: relative;
    display: block;
    &::after {
      content: "";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .learned {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 18px;
      background-color: rgba(0, 0, 0, 0.3);
      padding: 0 10px;
      line-height: 20px;
      color: #fff;
      font-size: 12px;
      text-align: right;
    }
  }
  .item-right {
    flex: 1;
    margin-left: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .course-tit {
    padding: 0 0;
    display: inline-block;
    width: 100%;
    font-size: 15px;
    color: #222;
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .course-info {
    font-size: 12px;
    color: #999;
    overflow: hidden;
    padding: 0 0;
  }
  .course-price {
    display: block;
    font-size: 12px;
    color: #6b3603;
    padding: 8px 0 0;
    line-height: 18px;
  }
}
</style>
